import { TOGGLE_GPC } from "../../constants/onlineShopper";

export interface ToggleGPCAction {
    type: TOGGLE_GPC;
}

export function toggleGPC(): ToggleGPCAction {
    return {
        type: TOGGLE_GPC,
    };
}
